import { all } from 'redux-saga/effects'

import watchGetList from './get-list'
import watchGetListSummary from './get-list-summary'
import watchSync from './sync'

export default function* sagas() {
  yield all([watchGetList(), watchGetListSummary(), watchSync()])
}
